import light from "./light.json";

// primary leads. accent fills use dark type so the yellow stays readable.
// secondary is the charcoal ink and dark chrome.

const cssVariables: Record<string, string> = {
  "--color-primary": light.colors.primary,
  "--color-primary-hover": light.colors.primaryHover,
  "--color-primary-soft": light.colors.primarySoft,
  "--color-on-primary": light.colors.onPrimary,
  "--color-secondary": light.colors.secondary,
  "--color-on-secondary": light.colors.onSecondary,
  "--color-accent": light.colors.accent,
  "--color-accent-hover": light.colors.accentHover,
  "--color-accent-soft": light.colors.accentSoft,
  "--color-on-accent": light.colors.onAccent,
  "--color-surface": light.colors.surface.header,
  "--color-border": "#D0D0D0",
};

if (typeof document !== "undefined") {
  const root = document.documentElement;
  Object.entries(cssVariables).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
}

const Theme = { light };

export default Theme;
